<div class="filters-dropdown" [class.hide]="!visible">
  <div class="filters-header section">
    <h2>Filters</h2>
    <button class="close" (click)="close()">X</button>
  </div>
  <div class="filters-body">
    <div class="filter-section-container mb-3">
      <h5 class="mb-2">Urgency</h5>
      <form class="checkboxes" [formGroup]="urgencyForm">
        <div class="row">
          <div class="col-3">
            <mat-checkbox
              id="Urgent"
              formControlName="Urgent"
              (change)="changeUrgency($event, 'Urgent')"
              >Urgent</mat-checkbox
            >
          </div>
          <div class="col-3">
            <mat-checkbox
              id="Routine"
              formControlName="Routine"
              (change)="changeUrgency($event, 'Routine')"
              >Routine</mat-checkbox
            >
          </div>
          <div class="col-3">
            <mat-checkbox
              id="Trauma"
              formControlName="Trauma"
              (change)="changeUrgency($event, 'Trauma')"
              >Trauma</mat-checkbox
            >
          </div>
          <div class="col-3">
            <mat-checkbox
              id="Stroke"
              formControlName="Stroke"
              (change)="changeUrgency($event, 'Stroke')"
              >Stroke</mat-checkbox
            >
          </div>
        </div>
      </form>
    </div>
    <div class="filter-section-container mb-3">
      <h5 class="mb-2">Modality</h5>
      <form class="checkboxes" [formGroup]="modalityForm">
        <div class="row">
          <div class="col-3">
            <mat-checkbox
              id="CT"
              formControlName="CT"
              (change)="changeModality($event, 'CT')"
              >CT</mat-checkbox
            >
          </div>
          <div class="col-3">
            <mat-checkbox
              id="MR"
              formControlName="MR"
              (change)="changeModality($event, 'MR')"
              >MR</mat-checkbox
            >
          </div>
          <div class="col-6">
            <mat-checkbox
              id="PlainFilm"
              formControlName="PlainFilm"
              (change)="changeModality($event, 'PlainFilm')"
              >Plain Film</mat-checkbox
            >
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <mat-checkbox
              id="US"
              formControlName="US"
              (change)="changeModality($event, 'US')"
              >US</mat-checkbox
            >
          </div>
          <div class="col-3">
            <mat-checkbox
              id="NM"
              formControlName="NM"
              (change)="changeModality($event, 'NM')"
              >NM</mat-checkbox
            >
          </div>
          <div class="col-3">
            <mat-checkbox
              id="PT"
              formControlName="PT"
              (change)="changeModality($event, 'PT')"
              >PT</mat-checkbox
            >
          </div>
          <div class="col-3">
            <mat-checkbox
              id="Other"
              formControlName="Other"
              (change)="changeModality($event, 'Other')"
              >Other</mat-checkbox
            >
          </div>
        </div>
      </form>
    </div>
    <hr class="mb-2" />
    <div class="filter-section-container mb-3">
      <h5 class="mb-2">Status</h5>
      <form class="checkboxes" [formGroup]="statusForm">
        <div class="row">
          <div class="col-sm">
            <mat-checkbox
              id="AwaitingFurtherDetails"
              formControlName="AwaitingFurtherDetails"
              (change)="changeStatus($event, 'AwaitingFurtherDetails')"
              >Awaiting Further Details</mat-checkbox
            >
          </div>
          <div class="col-sm">
            <mat-checkbox
              id="AwaitingImages"
              formControlName="AwaitingImages"
              (change)="changeStatus($event, 'AwaitingImages')"
              >Awaiting Images</mat-checkbox
            >
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <mat-checkbox
              id="TransferringImages"
              formControlName="TransferringImages"
              (change)="changeStatus($event, 'TransferringImages')"
              >Transferring Images</mat-checkbox
            >
          </div>
          <div class="col-sm">
            <mat-checkbox
              id="ReadyToReport"
              formControlName="ReadyToReport"
              (change)="changeStatus($event, 'ReadyToReport')"
              >Ready to Report</mat-checkbox
            >
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <mat-checkbox
              id="Reporting"
              formControlName="Reporting"
              (change)="changeStatus($event, 'Reporting')"
              >Reporting</mat-checkbox
            >
          </div>
          <div class="col-sm">
            <mat-checkbox
              id="Reported"
              formControlName="Reported"
              (change)="changeStatus($event, 'Reported')"
              >Reported</mat-checkbox
            >
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <mat-checkbox
              id="OnHoldMissingClinicalHistory"
              formControlName="OnHoldMissingClinicalHistory"
              (change)="changeStatus($event, 'OnHoldMissingClinicalHistory')"
              >On Hold - Missing Clinical History</mat-checkbox
            >
          </div>
          <div class="col-sm">
            <mat-checkbox
              id="OnHoldMissingDocumentation"
              formControlName="OnHoldMissingDocumentation"
              (change)="changeStatus($event, 'OnHoldMissingDocumentation')"
              >On Hold - Missing Documentation</mat-checkbox
            >
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <mat-checkbox
              id="OnHoldMissingImages"
              formControlName="OnHoldMissingImages"
              (change)="changeStatus($event, 'OnHoldMissingImages')"
              >On Hold - Missing Images</mat-checkbox
            >
          </div>
          <div class="col-sm">
            <mat-checkbox
              id="OnHoldMissingPriors"
              formControlName="OnHoldMissingPriors"
              (change)="changeStatus($event, 'OnHoldMissingPriors')"
              >On Hold - Missing Priors</mat-checkbox
            >
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <mat-checkbox
              id="OnHoldReviewOrderDetails"
              formControlName="OnHoldReviewOrderDetails"
              (change)="changeStatus($event, 'OnHoldReviewOrderDetails')"
              >On Hold - Review Order Details</mat-checkbox
            >
          </div>
          <div class="col-sm">
            <mat-checkbox
              id="OnHoldMissingPriorImages"
              formControlName="OnHoldMissingPriorImages"
              (change)="changeStatus($event, 'OnHoldMissingPriorImages')"
              >On Hold - Missing Prior Images</mat-checkbox
            >
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <mat-checkbox
              id="Cancelled"
              formControlName="Cancelled"
              (change)="changeStatus($event, 'Cancelled')"
              >Cancelled</mat-checkbox
            >
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="filters-footer section">
    <button
      mat-stroked-button
      class="clear"
      [disabled]="noPendingFilters$ | async"
      (click)="clearPendingFilters()"
    >
      Clear All Filters
    </button>
    <button
      mat-stroked-button
      class="submit"
      [disabled]="!dirty"
      (click)="submitFilters()"
    >
      Apply Filter
    </button>
  </div>
</div>
